module.exports = __webpack_public_path__ + "media/images/icon_postlist-573ef0244173176ae95e7f304a04eb71.svg";